// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
export default new Vue;



// WEBPACK FOOTER //
// ./src/Bus.js